import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { URLSearchParams } from '@angular/http';

@Injectable()
export class LoyaltyCardHomingService {

  public baseUrl: string = '/koncentro-loyalty/cards';

  constructor (
    private http: HttpClientService,
  ) { }

  list(offset = null, limit = null, search?: Array<{ key: string, value: string }>) {
    const params: URLSearchParams = new URLSearchParams();
    if ( search ) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }
    if ( offset !== null ) {
      params.set('offset', offset.toString());
    }
    if ( limit !== null ) {
      params.set('limit', limit.toString());
    }
    params.set('flg_manual', "1");
    return this.http.getPaged(this.baseUrl + '/getCardHoming?' + params.toString());
  }

  readyDeploy(cardHomingId) {
    return this.http.put(this.baseUrl + '/deployCardHoming/' + cardHomingId + '/update', null);
  }

  resetDeploy(cardHomingId) {
    return this.http.put(this.baseUrl + '/deployCardHoming/' + cardHomingId + '/reset', null);
  }

  /**
   * Effettua una nuova domiciliazione di carte, con i parametri card_no_start e card_no_end valorizzati se
   * operation_type = 2 (domiciliazione per Range). Per operation_type = 3 (domiciliazione per Negozio),
   * i due parametri su citati saranno pari a null.
   * @param params
   */
  postCardHoming(params: { store_src_id: number, store_dest_id: number, card_id?: number, card_no_start?: string, card_no_end?: string, operation_type: number }) {
    return this.http.post(this.baseUrl + '/cardHoming', params);
  }

  kloyCardHoming(params: any, companyCode: number) {
    return this.http.put(`koncentro-api/kloy/cardHoming?companyCode=${companyCode}`, params);
  }

  enableCard(cardNo) {
    return this.http.put(`${this.baseUrl}/enableCard`, {card_no: cardNo});
  }

  /*
  disableCard(cardNo) {
    return this.http.put(`${this.baseUrl}/disableCard`, {card_no: cardNo});
  }
  */

}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-card-homing.service.ts